import React from 'react'
import DefaultErrorMessage from './errorMessage'

// The DefaultErrorBoundary must be a React Class Component
// as opposed to a Functional Component this is
// because of the componentDidCatch() requirement
class DefaultErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // We can use google analytics here to log error events
    console.error(error, errorInfo)
  }

  render() {
    const { props, state } = this
    if (state.hasError) {
      return (
        <React.Fragment>
          {props.message
            ? props.message
            : <DefaultErrorMessage error="Default Error Boundary" data-testId="error-container"/>}
        </React.Fragment>
      )
    }
    return props.children
  }
}

export default DefaultErrorBoundary
